import { useTranslation } from 'react-i18next'
import { OPERADORES, SIN_VALOR } from './filtrosLogica'
import { TIPO_ICON } from './tipos'

const ctl = 'border border-gray-200 rounded-lg px-2.5 py-1.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-200'

let nextId = 1

// The value box for a filter, shaped by the column's type.
function ValorInput({ columna, filtro, onChange }) {
  const { t } = useTranslation('engineering')
  if (SIN_VALOR.has(filtro.op)) return null
  const common = { value: filtro.valor ?? '', onChange: e => onChange(e.target.value), className: `${ctl} w-44` }
  if (columna.tipo === 'estado') {
    return (
      <select {...common}>
        <option value="">{t('unidades.filtros.pickValue')}</option>
        {(columna.opciones || []).map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    )
  }
  if (columna.tipo === 'fecha') return <input type="date" {...common} />
  if (columna.tipo === 'numero') return <input type="text" inputMode="decimal" placeholder="0" {...common} />
  return <input type="text" placeholder={t('unidades.filtros.valuePlaceholder')} {...common} />
}

// "Filtrar por columna": rows of [column] [operator] [value]; all must match.
export default function PlanillaFiltros({ columnas, filtros, onChange }) {
  const { t } = useTranslation('engineering')

  const colDe = (f) => columnas.find(c => String(c.id) === String(f.campo))
  const update = (id, patch) => onChange(filtros.map(f => f.id === id ? { ...f, ...patch } : f))
  const remove = (id) => onChange(filtros.filter(f => f.id !== id))
  const add = () => {
    const c = columnas[0]
    onChange([...filtros, { id: nextId++, campo: c.id, op: OPERADORES[c.tipo][0], valor: '' }])
  }
  const setCampo = (f, campo) => {
    const c = columnas.find(x => String(x.id) === String(campo))
    // A new column may not offer the old operator, and the old value rarely fits.
    const op = OPERADORES[c.tipo].includes(f.op) ? f.op : OPERADORES[c.tipo][0]
    update(f.id, { campo: c.id, op, valor: '' })
  }

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-3 space-y-2">
      {filtros.map((f, i) => {
        const col = colDe(f)
        if (!col) return null
        return (
          <div key={f.id} className="flex items-center gap-2 flex-wrap">
            <span className="text-xs text-gray-400 w-8 shrink-0">{i === 0 ? t('unidades.filtros.where') : t('unidades.filtros.and')}</span>
            <select className={`${ctl} max-w-[16rem]`} value={f.campo} onChange={e => setCampo(f, e.target.value)}>
              {columnas.map(c => (
                <option key={c.id} value={c.id}>{c.fijo ? '' : `${TIPO_ICON[c.tipo]}  `}{c.nombre}</option>
              ))}
            </select>
            <select className={ctl} value={f.op} onChange={e => update(f.id, { op: e.target.value })}>
              {OPERADORES[col.tipo].map(op => (
                <option key={op} value={op}>{t(`unidades.filtros.ops.${col.tipo === 'archivo' ? 'archivo_' : ''}${op}`)}</option>
              ))}
            </select>
            <ValorInput columna={col} filtro={f} onChange={valor => update(f.id, { valor })} />
            <button type="button" onClick={() => remove(f.id)} title={t('unidades.filtros.remove')}
              className="w-7 h-7 rounded-md text-gray-400 hover:text-gray-700 hover:bg-gray-100 leading-none">×</button>
          </div>
        )
      })}
      <div className="flex items-center gap-4 pt-1">
        <button type="button" onClick={add} className="text-xs font-medium text-gray-600 hover:text-gray-900">
          {t('unidades.filtros.add')}
        </button>
        {filtros.length > 0 && (
          <button type="button" onClick={() => onChange([])} className="text-xs font-medium text-red-600 hover:text-red-700">
            {t('unidades.filtros.clearAll')}
          </button>
        )}
      </div>
    </div>
  )
}
